<div class="sidenav-hold">
  <div class="icon-menu mb-1" *ngIf="hasIconTypeMenuItem">
    <div class="icon-menu-item" *ngFor="let item of menuItems">
      <button *ngIf="!item.disabled && item.type === 'icon'" mat-raised-button
        [matTooltip]="item.tooltip" routerLink="/{{item.state}}"
        routerLinkActive="mat-bg-primary">
        <mat-icon>{{item.icon}}</mat-icon>
      </button>
    </div>
  </div>
  <ul appDropdown class="sidenav">
    <li *ngFor="let item of menuItems" appDropdownLink routerLinkActive="open" [style]="item.style"
      [routerLinkActiveOptions]="{ exact: item.type !== 'dropDown' && (item.state === 'ringpull/clearance' || item.state === '/ringpull/clearance') }">
      <div class="nav-item-sep" *ngIf="item.type === 'separator'">
        <mat-divider></mat-divider>
        <span class="text-muted">{{item.name | translate}}</span>
      </div>
      <div
        *ngIf="!item.disabled && item.type !== 'separator' && item.type !== 'icon'"
        class="lvl1">
        <a routerLink="/{{item.state}}" appDropdownToggle matRipple
          *ngIf="item.type === 'link'">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <span class="flex-grow"></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
        </a>

        <a [href]="item.state" appDropdownToggle matRipple
          *ngIf="item.type === 'extLink'" target="_blank">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <!-- <span fxFlex></span> -->
          <span class="flex-grow"></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
        </a>
        <!-- DropDown -->
        <a *ngIf="item.type === 'dropDown'" appDropdownToggle matRipple (click)="Testmenulog(item)">
          <mat-icon>{{item.icon}}</mat-icon>
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <!-- <span fxFlex></span> -->
          <span class="flex-grow"></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
          <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
        </a>
        <!-- LEVEL 2 -->
        <ul class="submenu lvl2" appDropdown *ngIf="item.type === 'dropDown'">
          <li *ngFor="let itemLvL2 of item.sub" appDropdownLink
            routerLinkActive="open"
            [routerLinkActiveOptions]="{ exact: itemLvL2.type !== 'dropDown' && (itemLvL2.state === 'ringpull/clearance' || itemLvL2.state === '/ringpull/clearance') }">
            <a [routerLink]="itemLvL2.state.startsWith('/') ? itemLvL2.state : '/' + itemLvL2.state"
              appDropdownToggle *ngIf="itemLvL2.type !== 'dropDown'" matRipple (click)="Testmenulog(itemLvL2)">
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <span class="flex-grow"></span>
            </a>
            <!-- use for v2 -->
            <a *ngIf="itemLvL2.type === 'dropDown'" appDropdownToggle matRipple (click)="Testmenulog(itemLvL2)" >
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <!-- <span fxFlex></span> -->
              <span class="flex-grow"></span>
              <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
            </a>
            <!-- LEVEL 3 -->
            <ul class="submenu lvl3" appDropdown
              *ngIf="itemLvL2.type === 'dropDown'">
              <li *ngFor="let itemLvL3 of itemLvL2.sub" appDropdownLink
                routerLinkActive="open"
                [routerLinkActiveOptions]="{ exact: itemLvL3.type !== 'dropDown' && (itemLvL3.state === 'ringpull/clearance' || itemLvL3.state === '/ringpull/clearance') }">
                <a [routerLink]="itemLvL3.state.startsWith('/') ? itemLvL3.state : '/' + itemLvL3.state"
                  appDropdownToggle matRipple (click)="Testmenulog(itemLvL3)">
                  <span
                    class="item-name lvl3">{{itemLvL3.name | translate}}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>
